import { render, staticRenderFns } from "./batchAppend.vue?vue&type=template&id=3aad87a6&"
import script from "./batchAppend.vue?vue&type=script&lang=js&"
export * from "./batchAppend.vue?vue&type=script&lang=js&"
import style0 from "./batchAppend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports